module.exports = __webpack_public_path__ + "img/Sergey.3dc33418.jpeg";